import React, { useEffect, useState } from 'react'
import { Link, navigate, PageProps } from 'gatsby'
import classnames from 'classnames'
import { Form } from './Form'
import { contactField, returnButton } from './Contact.module.scss'
import { Button } from '../../ui/Button'
import { ArrowRight } from '../../ui/Icon'
import { ExternalLink, InternalLink } from '../../ui/Link'

type Props = {
	location: PageProps['location']
}

export const ContactConfirm = ({ location }: Props) => {
	const [name, setName] = useState('')
	const [nameFurigana, setNameFurigana] = useState('')
	const [company, setCompany] = useState('')
	const [email, setEmail] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [content, setContent] = useState('')
	const [isSubmitting, setIsSubmitting] = useState(false)

	useEffect(() => {
		const { state } = location

		if (
			state === null ||
			state['name'] === undefined ||
			state['nameFurigana'] === undefined ||
			state['email'] === undefined ||
			state['content'] === undefined
		) {
			navigate('/contact/')
		}

		setName(state['name'] || '')
		setNameFurigana(state['nameFurigana'] || '')
		setCompany(state['company'] || '')
		setEmail(state['email'] || '')
		setPhoneNumber(state['phoneNumber'] || '')
		setContent(state['content'] || '')
	}, [location])

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()

		setIsSubmitting(true)

		const method = 'POST'
		const headers = {
			'Content-Type': 'application/json',
		}
		const body = {
			blocks: [
				{
					type: 'header',
					text: {
						type: 'plain_text',
						text: 'LisaHPからの新規お問い合わせ:smile:',
						emoji: true,
					},
				},
				{
					type: 'section',
					fields: [
						{
							type: 'mrkdwn',
							text: `*お名前:*\n${name}`,
						},
						{
							type: 'mrkdwn',
							text: `*お名前（フリガナ）:*\n${nameFurigana}`,
						},
					],
				},
				{
					type: 'section',
					fields: [
						{
							type: 'mrkdwn',
							text: `*会社名:*\n${company}`,
						},
					],
				},
				{
					type: 'section',
					fields: [
						{
							type: 'mrkdwn',
							text: `*メールアドレス:*\n${email}`,
						},
						{
							type: 'mrkdwn',
							text: `*電話番号:*\n${phoneNumber}`,
						},
					],
				},
				{
					type: 'section',
					text: {
						type: 'mrkdwn',
						text: `*お問い合わせ内容:*\n${content}`,
					},
				},
			],
		}

		await fetch('https://hooks.slack.com/services/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', {
			method,
			mode: 'no-cors',
			headers,
			body: JSON.stringify(body),
		})
			.then(() => navigate('/contact/fin/'))
			.catch(console.error)
	}

	return (
		<div className="w-full bg-form">
			<div className={contactField}>
				<div className="lg:p-10 py-10 px-5 mt-8 lg:mt-10 w-full bg-secondary rounded shadow">
					<p className="text-sm text-center">入力内容をご確認ください</p>
					<form className="mt-8" name="contact_form" method="POST" onSubmit={handleSubmit}>
						<Form
							name={name}
							nameFurigana={nameFurigana}
							company={company}
							email={email}
							phoneNumber={phoneNumber}
							content={content}
							readOnly={true}
							handleInputChange={() => {}}
							handleTextareaChange={() => {}}
						/>
						<p className="mt-8 text-xs text-center">
							<InternalLink href="/privacy" className="text-blue">
								プライバシーポリシー
							</InternalLink>
							に同意の上、お進みください
						</p>
						<div className="flex flex-col lg:flex-row justify-center items-center mt-8 fill-current">
							<Button className="w-52" type="submit" fluffy={true}>
								<span className="z-10">入力内容を送信する</span>
								<ArrowRight />
							</Button>
							<Link to="/contact/" state={{ name, nameFurigana, company, email, phoneNumber, content }}>
								<Button
									className={classnames(returnButton, 'mt-4 lg:mt-0 lg:ml-5 w-52')}
									type="button"
									fluffy={true}
									disabled={isSubmitting}
								>
									<span className="z-10">入力画面に戻る</span>
									<ArrowRight />
								</Button>
							</Link>
						</div>
					</form>
				</div>
				<p className="mt-5 lg:mt-8 text-xs">
					フォームで送信できない場合は、必要項目をご記入の上、
					<ExternalLink href="mailto:info@lisatech.jp" className="px-2 text-blue">
						info@lisatech.jp
					</ExternalLink>
					までメールをお送りください
				</p>
			</div>
		</div>
	)
}
